import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Form } from '../../services/form';
import ForgetPasswordModel from './forget-password.model';
import { NotificationService } from '../../notification/swal/notification.service';

import { ForgetPasswordService } from '../../services/forgetPassword.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.less']
})
export class ForgetPasswordComponent extends Form {

  forgetPasswordModel: ForgetPasswordModel = new ForgetPasswordModel();

  constructor(private forgetPasswordService: ForgetPasswordService,
              private notificationService: NotificationService,
              private router: Router) {
    super();
  }

  private requestRecoveryPassword() {
    this.forgetPasswordService.requestRecoveryPassword(this.forgetPasswordModel)
      .then((success) => {
        this.notificationService.showSuccessNotification('Verifique seu e-mail. Enviamos instruções para recuperar sua senha.');
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  recoveryPassword() {
    if (this.getFormStatus()) {
      this.requestRecoveryPassword();
    } else {
      this.notificationService.showErrorNotification('Todos os campos precisam estar válidos!');
    }
  }

  goBack(): void {
    this.router.navigate(['login']);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/forget-password/forget-password.component.ts